import * as Phaser from 'phaser';

/**
 * UIOverlayScene — a lightweight scene we keep running alongside the active
 * gameplay scene. Today it just hosts a top-corner network/presence dot; the
 * heavy HUD lives in the DOM (see src/ui/DomHud.ts) for crisp text rendering.
 */
export class UIOverlayScene extends Phaser.Scene {
  constructor() {
    super({ key: 'UIOverlayScene', active: false });
  }

  create(): void {
    const dot = this.add.graphics();
    dot.fillStyle(0x00ff9c, 1);
    dot.fillCircle(this.scale.width - 18, 18, 4);
    this.tweens.add({
      targets: dot,
      alpha: { from: 0.35, to: 1 },
      duration: 1400,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
  }
}
